<template>
  <div>
    <div style="position: relative; width: 100%">
      <lineChart
        :height="heightgrapg"
        :chartData="datacollection_power"
        :options="option_power"
      ></lineChart>
    </div>
  </div>
</template>

<script>
import lineChart from "./chart";
export default {
  components: { lineChart },
  props: ["text", "colorgraph", "heightgrapg", "datasets3", "datasets4"],
  data() {
    return {
      select1: 1,
      options_graph: [
        { text: "3 hr", value: 1 },
        { text: "6 hr", value: 2 },
        { text: "12 hr", value: 3 },
      ],
      datacollection_power: null,
      option_power: null,
    };
  },
  methods: {
    linechart() {
      this.datacollection_power = {
        labels: ["8 pm", "9 pm", "10 pm", "11 pm", "12 pm", "1 am", "2am"],
        // datasets: this.datasets3,
        datasets: [
          {
            // label: "Data One",
            fill: false,
            pointBackgroundColor: "#e",
            borderWidth: 3,
            pointRadius: 0, // <<< Here
            pointBorderColor: "#249EBF",
            data: [40, 20, 30, 50, 90, 10, 20, 40, 50, 70, 90, 100],
          },
        ],
      };
      this.option_power = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
                display: false,
                // steps: 5,
                // stepValue: 5,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                display: false,
              },
            },
          ],
        },
      };
    },
  },
  mounted() {
    this.linechart();
  },
};
</script>

<style scoped>
.aText {
  font-size: 0.1rem;
}
.al-center {
  align-items: center;
}
</style>